import {SidebarItem} from '../models/SidebarItem';
import React from "react";
import Matchs from "../components/Matchs";
import {BiHome} from "react-icons/bi";
import {TbCircleLetterA, TbSoccerField} from "react-icons/tb";
import {FaCog, FaDev, FaRegMinusSquare, FaRegPlusSquare, FaUsers} from "react-icons/fa";
import {Configurations, Results, Standings, UsersResults} from "../pages/Pages";
import {GrAchievement, GrUser, GrWorkshop} from "react-icons/gr";
import {FaPenToSquare, FaRankingStar, FaTrophy, FaUserShield} from "react-icons/fa6";
import About from "../components/About";
import Home from "../components/Home";
import CompetitionBets from "../components/CompetitionBets";
import GroupStandings from "../components/GroupStandings";
import ThirdOpponents from "../components/ThirdOpponents";
import {GiRank3} from "react-icons/gi";
import Groups from "../components/Groups";
import Squads from "../components/Squads";
import EmailVerify from "../components/Users/EmailVerify";
import Login from "../components/Users/Login-001";
import Classement from "../components/Users/Classement";
import UserRegister from "../components/Users/UserRegister";
import Development from "../components/Development";
import ResetPassword from "../components/Users/ResetPassword";
import AdminScores from "../components/Admin/AdminScores";
import AdminUsers from "../components/Admin/AdminUsers";
import AdminMatches from "../components/Admin/AdminMatches";
import AdminMatchesAtt from "../components/Admin/AdminMatchesAtt";
import Profile from "../components/Users/Profile";
import {FaRegUser} from "react-icons/fa6";
import ChatScreen from "../components/Chat/ChatScreen";
import {BsChatDots} from "react-icons/bs";

export const SidebarData: SidebarItem[] = [
    {
        title: '',
        path: '/',
        element: <Home/>,
        icon: <BiHome/>,
    },
    {
        title: 'Utilisateurs',
        path: '/users',
        element: <Matchs/>,
        icon: <GrUser/>,
        iconClosed: <FaRegPlusSquare/>,
        iconOpened: <FaRegMinusSquare/>,
        subnav: [
            {
                title: 'Connexion',
                path: '/users/login',
                element: <Login/>,
                icon: <GrWorkshop/>,
            },
            {
                title: 'Mon profil',
                path: '/users/profile',
                element: <Profile/>,
                icon: <FaRegUser/>,
                loggedInOnly: true,
            },
            {
                title: 'Annuaire',
                path: '/users/list',
                element: <AdminUsers readOnly/>,
                icon: <FaUsers/>,
                loggedInOnly: true,
            },
            {
                title: 'Inscription',
                path: '/users/register',
                element: <UserRegister/>,
                icon: <GrWorkshop/>,
            },
            {
                title: 'Résultats',
                path: '/users/results',
                element: <UsersResults/>,
                icon: <GrWorkshop/>,
            },
            {
                title: 'Classements',
                path: '/users/standings',
                element: <Classement/>,
                icon: <GiRank3/>,
            },
        ]
    },
    {
        title: 'Squads',
        path: '/squads',
        element: <Squads/>,
        icon: <FaUsers/>,
    },
    {
        title: 'Discussions',
        path: '/chat',
        element: <ChatScreen/>,
        icon: <BsChatDots/>,
        loggedInOnly: true,
    },
    {
        title: 'Compétition',
        path: '/competition',
        element: <CompetitionBets/>,
        icon: <FaTrophy/>,
        iconClosed: <FaRegPlusSquare/>,
        iconOpened: <FaRegMinusSquare/>,
        subnav: [
            {
                title: 'Paris avant la compétition',
                path: '/competition/bets',
                element: <CompetitionBets/>,
                icon: <FaTrophy/>,
            },
            {
                title: 'Classement réel des groupes',
                path: '/competition/standings',
                element: <GroupStandings/>,
                icon: <FaRankingStar/>,
            },
            {
                title: 'Adversaires 3èmes',
                path: '/competition/third-opponents',
                element: <ThirdOpponents/>,
                icon: <GiRank3/>,
            },
        ],
    },
    {
        title: 'Paris sur les matchs',
        path: '/matchs',
        element: <Matchs/>,
        icon: <TbSoccerField/>,
        iconClosed: <FaRegPlusSquare/>,
        iconOpened: <FaRegMinusSquare/>,
        subnav: [
            {
                title: 'Résultats',
                path: '/matchs/results',
                element: <Results/>,
                icon: <GrAchievement/>
            },
            {
                title: 'Classements',
                path: '/matchs/standings',
                element: <Standings/>,
                icon: <FaRankingStar/>,
            }
        ]
    },
    {
        title: 'Configurations',
        path: '/configurations',
        element: <Configurations/>,
        icon: <FaCog/>,
        subnav: [
            {
                title: 'Groupes',
                path: '/configuration/groups',
                element: <Groups/>,
                icon: <GrAchievement/>,
            },
        ],
    },
    {
        title: 'Administration',
        path: '/admin',
        element: <AdminScores/>,
        icon: <FaUserShield/>,
        iconClosed: <FaRegPlusSquare/>,
        iconOpened: <FaRegMinusSquare/>,
        adminOnly: true,
        subnav: [
            {
                title: 'Saisie des scores',
                path: '/admin/scores',
                element: <AdminScores/>,
                icon: <FaPenToSquare/>,
            },
            {
                title: 'Matches',
                path: '/admin/matches',
                element: <AdminMatches/>,
                icon: <TbSoccerField/>,
            },
            {
                title: 'Matchs prévisionnels',
                path: '/admin/matches-att',
                element: <AdminMatchesAtt/>,
                icon: <TbSoccerField/>,
            },
            {
                title: 'Utilisateurs',
                path: '/admin/users',
                element: <AdminUsers/>,
                icon: <FaUsers/>,
            },
        ],
    },
    {
        title: 'A propos',
        path: '/about',
        element: <About/>,
        icon: <TbCircleLetterA/>,
    },
    {
        title: 'Developpement',
        path: '/development',
        element: <Development/>,
        icon: <FaDev/>,
        development: true
    }
];

export interface IRoute {
    key?: string;
    reactElement?: React.ReactElement;
}

function extractRoutes(menuItems: SidebarItem[]): IRoute[] {
    const elements: IRoute[] = [];

    for (const menuItem of menuItems) {
        const newElement: IRoute = {
            key: menuItem.path,
            reactElement: menuItem.element
        }
        elements.push(newElement);

        if (menuItem.subnav) {
            const childElements = extractRoutes(menuItem.subnav);
            elements.push(...childElements);
        }
    }

    return elements;
}

const fixedRoutes: IRoute[] = [
    {
        key: '/user/EmailVerify?',
        reactElement: <EmailVerify/>
    },
    {
        key: '/user/ResetPassword?',
        reactElement: <ResetPassword/>
    },
]

const routesFromMenuItems: IRoute[] = extractRoutes(SidebarData);
console.log(routesFromMenuItems);
export const routes: IRoute[] = [...fixedRoutes, ...routesFromMenuItems];